import { render, staticRenderFns } from "./QuickItemListView.vue?vue&type=template&id=1f656b0a"
import script from "./QuickItemListView.vue?vue&type=script&lang=js"
export * from "./QuickItemListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f656b0a')) {
      api.createRecord('1f656b0a', component.options)
    } else {
      api.reload('1f656b0a', component.options)
    }
    module.hot.accept("./QuickItemListView.vue?vue&type=template&id=1f656b0a", function () {
      api.rerender('1f656b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quickitem/QuickItemListView.vue"
export default component.exports